import React from 'react';

const VersionHistoryIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.5459
                2H10.0004C9.1971
                2
                8.5459
                2.65123
                8.5459
                3.45457V16.5457C8.5459
                17.349
                9.1971
                18.0002
                10.0004
                18.0002H16.5459C17.3492
                18.0002
                18.0004
                17.349
                18.0004
                16.5457V3.45457C18.0004
                2.65123
                17.3492
                2
                16.5459
                2Z"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.72701
                3.09143C5.92368
                3.09143
                5.27246
                3.74266
                5.27246
                4.546V15.4551C5.27246
                16.2585
                5.92368
                16.9097
                6.72701
                16.9097"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            
            <path
                d="M3.45455
                4.18207C2.65122
                4.18207
                2
                4.8333
                2
                5.63664V14.3639C2
                15.1672
                2.65122
                15.8185
                3.45455
                15.8185"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            
            <path
                d="M13.2732
                12.7266C14.7794
                12.7266
                16.0004
                11.5056
                16.0004
                9.99929C16.0004
                8.49303
                14.7794
                7.27197
                13.2732
                7.27197C11.7669
                7.27197
                10.5459
                8.49303
                10.5459
                9.99929C10.5459
                11.5056
                11.7669
                12.7266
                13.2732
                12.7266Z"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M14.2313
                10.3191H13.0459V9.13373"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
       </svg>
    );
};

export default VersionHistoryIcon;